
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface ButtonProps extends KendoWidgetProps, kendo.ui.ButtonOptions {
    children?: React.ReactNode;
}

export default class Button extends KendoBaseComponent<ButtonProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.Button(domNode as Element, (props as kendo.ui.ButtonOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
        }

        return (
            <button ref={this.elementRef}>
                {this.props.children}
            </button>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-react-wrapper/src/button/index.tsx